<div
  class="global-entity-selector"
  [class.global-entity-selector--picker-open]="isPickerOpen"
  aria-label="Global entity selector"
>
  <nv-box-button
    id="entity-selector-trigger"
    [text]="label"
    [icon]="isSwitcherActive ? 'dropdown-white' : null"
    [isDisabled]="!isSwitcherActive"
    [iconAriaLabel]="isSwitcherActive ? 'Open picker' : 'Picker disabled'"
    (clickButton)="openPickerModal()"
  ></nv-box-button>
</div>
